import type React from 'react';

interface JumpInIconProps {
  size?: number;
  color?: string;
  className?: string;
}

/** @deprecated Use icons from icons-v2-generated instead. */
export const JumpInIcon: React.FC<JumpInIconProps> = ({ size = 48, color = 'white', className = '' }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M40.0934 52.722V59.5275M40.0934 52.722L31.3434 58.5553M40.0934 52.722L48.8434 58.5553M40.0934 52.722V47.8609M56.6211 20.6387V42.0276C56.6211 45.2492 54.0095 47.8609 50.7878 47.8609H29.3989C26.1773 47.8609 23.5656 45.2492 23.5656 42.0276V20.6387M56.6211 20.6387H59.5378M56.6211 20.6387H23.5656M23.5656 20.6387H20.6489M31.3434 39.1109L36.5895 33.8657C37.2203 33.235 38.1994 33.1144 38.9644 33.5732L41.2222 34.9274C41.9873 35.3862 42.9664 35.2656 43.5972 34.6348L48.8434 29.3887"
        stroke={color}
      />
      <path
        d="M16.6665 16.666L63.3332 63.3327M73.3332 39.9994C73.3332 58.4088 58.4093 73.3327 39.9998 73.3327C21.5903 73.3327 6.6665 58.4088 6.6665 39.9994C6.6665 21.5899 21.5903 6.66602 39.9998 6.66602C58.4093 6.66602 73.3332 21.5899 73.3332 39.9994Z"
        stroke={color}
      />
    </svg>
  );
};
